import React, { useState, useEffect } from "react";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
    getStatusLeadContacts,
    deleteStatusLeadContact
} from "../../../api/statusLeadContact";
import { usePagination } from "../../../hooks/usePagination";
import PaginationHandler from "../../../components/PaginationHandler";
import CustomTable from "../../../components/CustomTable/CustomTable";
import { Button, Input, Label } from "reactstrap";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";

const LEVEL_COLORS = {
    start: 'primary',
    failed: 'danger',
    final: 'success'
};

export default function StatusLeadContactList() {
    const navigate = useNavigate();
    const currentUser = JSON.parse(localStorage.getItem("currentUser")) || {};
    const role = currentUser.role || currentUser.roleName || "";

    const hasPermission = (action) => {
        if (role.name === "super admin") return true;
        return (
            role.permissions &&
            role.permissions.some(
                (perm) => perm.resource === "Sales" && perm.actions.includes(action)
            )
        );
    };

    
    const canCreate = () => hasPermission("create");
    const canEdit = () => hasPermission("update");
    const canDelete = () => hasPermission("delete");
    const canRead = () => hasPermission("delete") || hasPermission("update");

    useEffect(() => {
        console.log("Current User:", currentUser);
        console.log("Role:", role.name);
        console.log("Permissions:", role.permissions);
    }, [currentUser]);

    const {
        response,
        loading,
        error,
        setPage,
        page,
        setMeta,
        totalPages,
    } = usePagination(getStatusLeadContacts, null, true);

    const [filters, setFilters] = useState({
        name: "",
        status: "",
    });

    function handleFilter() {
        setMeta((m) => ({
            ...m,
            page: 1,
            payload: {
                ...filters,
            },
        }));
    }

    const handleDelete = async (id) => {
        if (window.confirm(t("Are you sure you want to delete this lead contact status?"))) {
            try {
                await deleteStatusLeadContact(id);
                setPage(1);
            } catch (error) {
                console.error("Delete failed:", error);
                alert(t("Failed to delete lead contact status."));
            }
        }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                {/* Breadcrumb with conditional add button */}
                <Breadcrumbs
                    title={t("Lead Contact Status")}
                    addUrl={canCreate() ? "/statusleadcontacts/add" : null}
                    hasAddBtn={canCreate()}
                    isMainPage={true}
                />

                {/* Conditionally render table */}
                {canRead() || canEdit() || canDelete() ? (
                    response && response.length > 0 && !loading ? (
                        <CustomTable
                            emptyMsg={t("No Lead Contact Statuses Found.")}
                            data={response}
                            loading={loading}
                            error={error}
                            cols={[
                                {
                                    label: t("Name"),
                                    key: "name",
                                    style: { width: "33%" },
                                    renderer: (row) => row.name || "N/A",
                                },
                                {
                                    label: t("Level"),
                                    key: "level",
                                    style: { width: "33%" },
                                    renderer: (row) => {
                                        const color = LEVEL_COLORS[row.level] || 'secondary';
                                        return (
                                            <div className="d-flex align-items-center gap-2">
                                                <span className={`badge bg-${color} text-capitalize`}>
                                                    <span className="me-1">★</span>
                                                    {t(row.level)}
                                                </span>
                                            </div>
                                        );
                                    },
                                },
                                {
                                    label: t("Actions"),
                                    key: "actions",
                                    style: { width: "34%" },
                                    renderer: (row) => (
                                        <div className="d-flex gap-2">
                                            {canEdit() && (
                                                <Button
                                                    color="info"
                                                    size="sm"
                                                    onClick={() => navigate(`/statusleadcontacts/edit/${row._id}`)}
                                                >
                                                    {t("Edit")}
                                                </Button>
                                            )}
                                            {canDelete() && (
                                                <Button
                                                    color="danger"
                                                    size="sm"
                                                    onClick={() => handleDelete(row._id)}
                                                >
                                                    {t("Delete")}
                                                </Button>
                                            )}
                                        </div>
                                    ),
                                },
                            ]}
                        />
                    ) : (
                        !loading && <div>{t("No results found.")}</div>
                    )
                ) : (
                    <div>{t("You do not have permission to view this list.")}</div>
                )}

                {/* Pagination */}
                {response && !loading && canRead() && (
                    <PaginationHandler
                        page={page}
                        setPage={setPage}
                        totalPages={totalPages}
                    />
                )}
            </div>
        </div>
    );
}
